import React, { useEffect, useState } from "react";
import "./hero.css"; 

const Hero = () => {
  const [text, setText] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const fullText = "Front End Developer";
  const typingSpeed = 250; // Velocidad de escritura en milisegundos

  // Detectar si es móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    let index = 0;
    let typingInterval;

    // Pequeño delay inicial para evitar conflictos de traducción
    const startTyping = () => {
      typingInterval = setInterval(() => {
        if (index < fullText.length) {
          setText(fullText.slice(0, index + 1));
          index++;
        } else {
          clearInterval(typingInterval);
        }
      }, typingSpeed);
    };

    // Iniciar después de un pequeño delay
    const timeout = setTimeout(startTyping, 500);

    return () => {
      clearTimeout(timeout);
      clearInterval(typingInterval);
    };
  }, [fullText, typingSpeed]);

  // Función para manejar el clic en la flecha
  const handleArrowClick = (e) => {
    e.preventDefault(); // Evitar el comportamiento por defecto del enlace
    const nextSection = document.getElementById("next-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" }); // Desplazamiento suave
    }
  };

  return (
    <>
      <div className="hero">
        <h1 
          className={`typewriter ${isMobile ? 'mobile' : ''}`}
          translate="no"
          data-translate="no"
          lang="en"
        >
          {text}
          <span className="cursor">|</span> {/* Cursor grande y titilante */}
        </h1>
        <a href="#next-section" className="arrow-down" onClick={handleArrowClick}>
           {/* flecha */}
        </a>
      </div>

      {/* Siguiente sección */}
      <div id="next-section" className="next-section">
        <div className="intro-content">
          <h2 className="intro-title">Hola, ya vengo</h2>
          <p className="intro-subtitle">Creando experiencias digitales</p>
          <div className="contact-section">
            <span className="contact-label">¿Tenés un proyecto en mente?</span>
            <a href="mailto:hola@melisascime.com.ar" className="contact-link">
              Escribime →
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
